const TeamSerialNumber = ({ teamNumber, isInactive = false }) => {
  return (
    <div
      className={`si-team__serialNumber si-team__serialNumber_team${teamNumber} ${
        isInactive ? `si-team__serialNumber-inactive` : ``
      }`}
    >
      <span className="si-team__serialNumber-text">
        {teamNumber ? `T${teamNumber?.toString()}` : "-"}
      </span>
    </div>
  );
};

export default TeamSerialNumber;
